// extracted by mini-css-extract-plugin
export default {"LoadingContainer":"styles_LoadingContainer__iDmCn","ldsRoller":"styles_ldsRoller__MZSGX","lds-roller":"styles_lds-roller__Os4Up"};